<template>
  <layout-general v-if="modalVisible === 'duplicate-step'" @close="modalClose()">
    <h4 class="modal-title" slot="header">{{ $t('general.actions.duplicate') }} {{ $t('general.labels.step') }}</h4>
    <div slot="body">
      <div>
        <h4 class="help-block">{{ $t('modal.duplicate_step.are_you_sure') }}</h4>
      </div>
      <div>
        <p class="help-block">
          {{ $t('general.actions.duplicate') }}
          <select class="klickart-select" style="width: 60px" v-model="number">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
          {{ $t('general.labels.times') }}
        </p>
      </div>
    </div>
    <div slot="footer">
      <button @click="stepDuplicate(number)" class="btn btn-success">
         <span class="txt">{{ $t('modal.duplicate_step.yes') }}</span>
      </button>
      <button @click="modalClose()" class="btn btn-default">
         <span class="txt">{{ $t('general.actions.cancel') }}</span>
      </button>
    </div>
  </layout-general>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LayoutGeneral from './layout/General.vue';

export default {
  data() {
    return {
      number: 1,
    };
  },
  components: {
    LayoutGeneral,
  },
  computed: mapGetters({
    modalVisible: 'modalVisible',
  }),
  methods: mapActions([
    'stepDuplicate',
    'modalClose',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** DuplicateStep.vue?0b83e0a0
 **/